import * as ActionCreators from 'redux/actionCreators';
import SchedulingService from 'services/SchedulingService';
import DesignServicesService from 'services/designServices/DesignServicesService';
import { getLocalizedText } from '@vp-dst/localization-util';

export function getAvailableDates(timezone) {
  return async (dispatch, getState) => {
    try {
      dispatch(ActionCreators.setAvailableDatesLoading(true));

      const calendarId = getState().selectedDesigner;

      const schedulingService = new SchedulingService(window.model.BriefViewModel.SubmitFormHost);

      const availableDates = await schedulingService.getAvailableDates(timezone, calendarId);

      dispatch(ActionCreators.setAvailableDatesSuccess(availableDates));
    } catch (error) {
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-determine-available-dates');

      dispatch(ActionCreators.setAvailableDatesFailure(errorMessage));
    }
  };
}

export function getAvailableTimes(date, timezone) {
  return async (dispatch, getState) => {
    try {
      dispatch(ActionCreators.setAvailableTimesLoading(true));

      const calendarId = getState().selectedDesigner;

      const schedulingService = new SchedulingService(window.model.BriefViewModel.SubmitFormHost);

      const availableTimes = await schedulingService.getAvailableTimes(date, timezone, calendarId);

      // temporarily show all available times
      // const minHourOfDay = 7;
      // const maxHourOfDay = 22;

      // const displayableTimes = availableTimes.filter((timeString) => {
      //   const time = moment(timeString).tz(timezone);
      //   const localizedHourOfDay = time.get('hour');
      //   return localizedHourOfDay >= minHourOfDay && localizedHourOfDay <= maxHourOfDay;
      // });

      const displayableTimes = availableTimes;

      dispatch(ActionCreators.setAvailableTimesSuccess(displayableTimes));
    } catch (error) {
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-determine-available-time-slots');

      dispatch(ActionCreators.setAvailableTimesFailure(errorMessage));
    }
  };
}

export function submitHolidayUGOrder(request) {
  return async (dispatch) => {
    try {

      console.log("submit")
      dispatch(ActionCreators.setOrderSubmitting(true));

      const designServicesService = new DesignServicesService();

      await designServicesService.submitUploadGoRequest(request);

      window.location = '/design-services/dashboard.aspx';

      dispatch(ActionCreators.submitDifyOrderSuccess());
    } catch (error) {
      console.error(error);
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-place-order-at-this-time');

      dispatch(ActionCreators.submitDifyOrderFailure(errorMessage));
    }
  };
}

export function submitCoDesignOrder(coDesignOrderDTO) {
  return async (dispatch) => {
    try {
      dispatch(ActionCreators.setOrderSubmitting(true));

      const designServicesService = new DesignServicesService(window.model.BriefViewModel.SubmitFormHost);

      await designServicesService.submitCoDesignOrder(coDesignOrderDTO);

      window.location = '/cart.aspx';

      dispatch(ActionCreators.submitCoDesignOrderSuccess());
    } catch (error) {
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-place-order-at-this-time');

      dispatch(ActionCreators.submitCoDesignOrderFailure(errorMessage));
    }
  };
}

export function submitDifyOrder(difyOrderDTO) {
  return async (dispatch) => {
    try {
      dispatch(ActionCreators.setOrderSubmitting(true));

      const designServicesService = new DesignServicesService(window.model.BriefViewModel.SubmitFormHost);

      await designServicesService.submitDifyOrder(difyOrderDTO);

      window.location = '/cart.aspx';

      dispatch(ActionCreators.submitDifyOrderSuccess());
    } catch (error) {
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-place-order-at-this-time');

      dispatch(ActionCreators.submitDifyOrderFailure(errorMessage));
    }
  };
}

export function saveDifyOrder(difyOrderUpdateDTO) {
  return async (dispatch) => {
    try {
      dispatch(ActionCreators.setOrderSubmitting(true));

      const designServicesService = new DesignServicesService(window.model.BriefViewModel.SubmitFormHost);

      await designServicesService.saveDifyOrder(difyOrderUpdateDTO);

      window.location = '/cart.aspx';

      dispatch(ActionCreators.saveDifyOrderSuccess());
    } catch (error) {
      const errorMessage = (error && error.displayMessage) ? error.displayMessage : getLocalizedText('unable-to-save-order-at-this-time');

      dispatch(ActionCreators.saveDifyOrderFailure(errorMessage));
    }
  };
}


// WEBPACK FOOTER //
// ./src/redux/thunkActionCreators.js